import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import Data_Grid from "../biztran_controls/DataGrid";
import AddExpenseSheet from "../Approvels/ManagerApproveExpense";
// import { Home } from "@material-ui/icons";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';


const PendingManagerApproval = (props) => {
    debugger;
    const [FromDate, setFromDate] = useState(fromdate);
    const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [isOpen, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [Count, setCount] = useState();
    const [Employee, setEmployee] = useState('');
    const [Manager, setManager] = useState('');
    const [TravelRequestID, setTravelRequestID] = useState('');
    const [TravelLocation, setTravelLocation] = useState('');
    const [Status, setStatus] = useState('');
    const [Statuscmb, setStatuscmb] = useState([]);
    const [ExpenseID, setExpenseID] = useState('');
    const [response, fetchData] = UseFetchData();


    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }

    const openModal = (row) => {
        debugger;
        setTravelRequestID(row.id);
        setOpen(true);
    };

    const handleOpenModal = () => {
        setExpenseID('');
        setOpen(true);
    };

    const PopulateData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("TravelRequestID", "");
        bodyFormData.append("LocationToTravel", "");
        bodyFormData.append("EmpName", "");
        bodyFormData.append("Manager", "");
        bodyFormData.append("ApprovalStatus", "");
        bodyFormData.append("FromDate", "");
        bodyFormData.append("ToDate", "");
        bodyFormData.append("Page", "Home");
        fetchData("Dashboard/pendingManagerApproval", bodyFormData);
    }

    useEffect(() => {
        const gridCols = [
            {
                field: "id",
                headerName: "Select",
                //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
                renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 70,

            },
            {
                field: "TravelRequestNo",
                headerName: "Travel Req No",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "TravelRequestDate",
                headerName: "Travel Req Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                type: 'date',

            },
            {
                field: "EmpCode",
                headerName: "Emp Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "EmpName",
                headerName: "Emp Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "ApprovalStatus",
                headerName: "Status",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "AccountsApprovedOn",
                headerName: "Acc Approved On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
                type: 'date',
            },
            {
                field: "ExpenseApprovedBy",
                headerName: "Mngr Approved By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },
            {
                field: "ExpenseApprovedOn",
                headerName: "Mngr Approved On",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },

        ];
        setColumns(gridCols);
        setRows(response);
        setCount(response.length);
    }, [response]
    );

    useEffect(() => {
        PopulateData();
    }, [])

    return (
        <div>
            <Paper elevation={0}>
                <Grid container="row">

                    {/* <Grid spacing={1} container direction="row"> */}
                    <Grid item xs={12} container direction='row'>
                        <Grid item xs={8} >
                            <label
                                htmlFor={"PendingExpensesForApproval"}
                                style={{
                                    display: "block",
                                    width: "100%",
                                    fontSize: 25,
                                    fontWeight: "bold",
                                    marginTop: 10

                                }}
                            >
                                {"Pending Expenses For Approval"}
                            </label>
                        </Grid>
                    </Grid>
                    {/* <Grid item spacing={2} xs={12} container direction='row'>
                            <Grid item xs={8} >
                                <label
                                    htmlFor={"WrongCallAllocation"}
                                    style={{
                                        display: "block",
                                        width: "100%",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                    }}
                                >
                                    {"Wrong Call Allocation"}
                                </label>
                            </Grid>
                        </Grid> */}
                    {/* </Grid> */}
                    {/* <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setFromDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                className='my-react-component'
                                onClear={() => { onFromClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultfromDate}
                            >
                            </DatePickerInput>
                        </div>
                    </Grid> */}
                    {/* <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
                        <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
                            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                            <DatePickerInput
                                onChange={(jsDate, dateString) => setToDate(dateString)}
                                locale="en"
                                displayFormat="DD/MMM/YYYY"
                                className='my-react-component'
                                onClear={() => { onToClear(); }}
                                showOnInputClick
                                maxDate={new Date()}
                                returnFormat="YYYY/MM/DD"
                                defaultValue={defaultToDate}
                            >
                            </DatePickerInput>
                        </div>
                    </Grid> */}
                </Grid>
                <br />
                <Grid container="row" marginTop={1} >
                    {/* <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Employee"
                                    id="Employee"
                                    onChange={(e) => setEmployee(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid> */}
                    {/* <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
                        <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
                            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Input
                                    label="Manager"
                                    id="Manager"
                                    onChange={(e) => setManager(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid> */}
                    {/* <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
                        <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
                    </div> */}
                </Grid>

                <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
                    {/* <Grid xs={12} md={5} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                        <div style={{ width: "110%", marginLeft: 3, marginTop: 2 }} >
                            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                                <BiztranControls.Input
                                    label="Travel Location"
                                    id="TravelLocation"

                                    onChange={(e) => setTravelLocation(e.target.value)}
                                />
                            </div>
                        </div>
                    </Grid> */}
                    {/* <Grid xs={12} md={2} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
                        <div style={{ width: "110%", marginLeft: 2, marginTop: 2 }} >
                            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                                <BiztranControls.Select
                                    label="Status"
                                    id="Status"
                                    options={Statuscmb}
                                    onChange={(e) => setStatus(e.target.value)}
                                />
                            </div></div>
                    </Grid> */}
                    <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
                        <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
                            {/* <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                                <BiztranControls.Button
                                    text="SEARCH"
                                    startIcon={<SearchIcon />}
                                    style={{ marginTop: '10%' }}
                                    onClick={() => {
                                        PopulateData();
                                    }}
                                />
                            </div> */}
                            {/* <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
                <BiztranControls.Button
                  text="ADD NEW"
                  startIcon={<AddCircleOutlineIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    handleOpenModal();
                  }}
                />
              </div> */}

                        </div>
                    </Grid>
                </Grid>

                <Modal_Frame
                    title="Expense Sheet Approval"
                    maxWidth="md"
                    Height="300px"
                    isOpen={isOpen}
                    setOpen={setOpen}
                >
                    <AddExpenseSheet
                        TravelRequestID={TravelRequestID}
                        setOpen={setOpen}
                        PopulateData={PopulateData}
                        pagename={"Home"}
                        Status={Status}
                    />
                </Modal_Frame>

                <BiztranControls.DataGrid
                    rowHeight={25}
                    headerHeight={34}
                    rows={rows}
                    columns={columns}
                    checkboxSelection={false}
                    // autoHeight={true}
                    Width="107%"
                    Height="500px"
                    hideFooter={true}
                />
            </Paper>
        </div>
    )
}

export default PendingManagerApproval;